import styled from "styled-components";
import theme from "~/styles/theme";
import FBSocial from "~/assets/img/social/facebook.svg";
import IGSocial from "~/assets/img/social/instagram.svg";
import YTSocial from "~/assets/img/social/youtube.svg";

export const BgFooter = styled.div`
  background-color: ${theme.palette.brand.primary.key};
  padding: 0 16px;

  @media (min-width: ${theme.breakpoints.values.md}px) {
    padding: 0;
  }

  p {
    color: ${theme.palette.neutral.primary.light};

    a {
      color: ${theme.palette.neutral.primary.light};
      text-decoration: none;

      &:hover {
        text-decoration: underline;
      }
    }
  }
`;

export const FBButton = styled.div`
  width: 40px;
  height: 40px;
  cursor: pointer;
  transition: ${theme.transition};
  background: url(${FBSocial});
  background-size: cover;

  @media (min-width: ${theme.breakpoints.values.md}px) {
    width: 32px;
    height: 32px;
  }
`;
export const IGButton = styled.div`
  width: 40px;
  height: 40px;
  cursor: pointer;
  transition: ${theme.transition};
  background: url(${IGSocial});
  background-size: cover;

  @media (min-width: ${theme.breakpoints.values.md}px) {
    width: 32px;
    height: 32px;
  }
`;
export const YTButton = styled.div`
  width: 40px;
  height: 40px;
  cursor: pointer;
  transition: ${theme.transition};
  background: url(${YTSocial});
  background-size: cover;

  @media (min-width: ${theme.breakpoints.values.md}px) {
    width: 32px;
    height: 32px;
  }
`;

export const SVGHolder = styled.div`
  width: 169px;
  height: 39px;
  cursor: pointer;
  svg {
    width: 100%;
    height: 100%;
  }
`;

export const LinksHolder = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  align-items: center;

  strong {
    font-size: 14px;

    @media (min-width: ${theme.breakpoints.values.md}px) {
      font-size: 16px;
    }
  }

  a {
    font-size: 16px;
    &:hover {
      text-decoration: underline;
    }
  }
  a,
  span {
    margin-bottom: 32px;
    cursor: pointer;
    text-decoration: none;
    color: ${theme.palette.neutral.primary.light};
    text-transform: uppercase;
    font-size: 14px;
    font-weight: 500;
  }
  @media (min-width: ${theme.breakpoints.values.md}px) {
    flex-direction: row;
    width: fit-content;
    a {
      margin: 0;
    }
    span {
      margin: 0 28px 0 0;
    }
  }
`;
export const SocialHolder = styled.div`
  display: flex;
  > a {
    margin-left: 27px;
  }
`;

export const Disclaimer = styled.div`
  p {
    color: ${theme.palette.neutral.primary.light};
    font-family: ${theme.typography.fontFamilyRegular};

    text-align: justify;
    font-size: 12px;
    font-style: normal;
    font-weight: 400;
    line-height: 16px; /* 133.333% */
  }
`;

export const Border = styled.div`
  border-bottom: 1px solid ${theme.palette.neutral.primary.light};
  width: 100%;
  margin-top: 13px;
`;

export const Border2 = styled.div`
  border-bottom: 1px solid ${theme.palette.neutral.primary.light};
  width: 100%;
  margin-top: 16px;
  margin-bottom: 16px;
`;

export const Contact = styled.div`
  display: flex;
  flex-direction: column;

  @media (min-width: ${theme.breakpoints.values.md}px) {
    flex-direction: row;
  }

  .title {
    color: ${theme.palette.neutral.primary.light};
    margin-right: 34px;
    display: block;
  }

  strong {
    display: contents;
  }

  p {
    display: flex;
    font-size: 12px;

    @media (min-width: ${theme.breakpoints.values.md}px) {
      font-size: 14px;
    }

    svg {
      margin-right: 8px;
    }
  }

  a {
    color: ${theme.palette.neutral.primary.light};
    text-decoration: none;
    display: contents;
    font-size: 12px;

    @media (min-width: ${theme.breakpoints.values.md}px) {
      font-size: 14px;
    }
  }
`;

export const FooterContact = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;

  @media (min-width: ${theme.breakpoints.values.md}px) {
    flex-direction: column;
  }
`;

export const FooterContactItem = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 0px;
`;
